export function getClassName(
  baseClassSuffix: string,
  additionalClassNames: string | string[] = [],
): string {
  return [
    `suntex-${baseClassSuffix}`,
    ...(typeof additionalClassNames === 'string'
      ? [additionalClassNames]
      : additionalClassNames),
  ].join(' ');
}
